import { useContext, useEffect } from "react";
import { Container, Typography, Button, Box } from "@mui/material";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import AuthContext from "../../contexts/AuthContext";
import { useNavigate } from "react-router-dom";

const NoPermission = () => {
  const { isAuthLoading, logout, userLoggedData } = useContext(AuthContext);

    const navigate = useNavigate();

    useEffect(() => {
  
      if (isAuthLoading) {
        return;
      }
      if (!userLoggedData) {
        navigate("/login");
      }
    }, [userLoggedData, isAuthLoading, navigate]);

  return (
    <Container maxWidth="sm" sx={{ textAlign: "center", mt: 10 }}>
      <Box
        sx={{ p: 3, border: 1, borderColor: "divider", borderRadius: 2, boxShadow: 3 }}
      >
        <Typography variant="h3" color="error" gutterBottom>
          Acesso Negado
        </Typography>
        <Typography variant="body1" gutterBottom>
          Você não tem permissão para acessar este sistema.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          sx={{ mt: 2 }}
          onClick={logout}
          endIcon={<ExitToAppIcon />}
        >
          Sair
        </Button>
      </Box>
    </Container>
  );
};

export default NoPermission;
